/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";

import SelectInput2 from "../../component/input/SelectInput2";
import TextInput2 from "../../component/input/TextInput2";
import {
  isSuperAdmin,
  renderAccessLocation2,
  renderLocationFunction
} from "../../constant/helper/helper";
import SpinnerButton from "../../component/spinner/SpinnerButton";
import Button from "../../component/button/Button";
import RenderToolTip from "../../component/tooltip/RenderToolTip";
import { toolTipData } from "./deviceStaticData";

const TopInput = ({
  values,
  loading,
  onSubmit,
  onChange,
  allLocations,
  currentUser
}) => {
  return (
    <div className="row">
      <RenderToolTip toolTipData={toolTipData} />
      <div className="col-lg-3 col-md-3">
        <SelectInput2
          data-tip
          name="locationId"
          isLabeled={true}
          onChange={onChange}
          icon="mdi mdi-map-marker-radius"
          data-for="locationId"
          label="Select Location"
          value={values.locationId}
          placeholder="Select Location"
        >
          {isSuperAdmin(currentUser)
            ? renderLocationFunction(allLocations)
            : renderAccessLocation2(
                JSON.parse(localStorage.getItem("selectedModule"))
              )}
        </SelectInput2>
      </div>

      {loading === true ? (
        <div className="col-sm-2 col-lg-2 col-md-2">
          <SpinnerButton />
        </div>
      ) : (
        <div className="col-lg-2 col-md-2">
          <div className="form-group">
            <Button
              type="button"
              onClick={onSubmit}
              title="GET"
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn mb-2 text-white btn-dark btn-block"
            />
          </div>
        </div>
      )}
      <div className="col-lg-3 col-md-3">
        <TextInput2
          data-tip
          type="text"
          name="Filter"
          onChange={onChange}
          value={values.Filter}
          data-for="Filter"
          icon="mdi mdi-table-search"
          placeholder="Search..."
        />
      </div>
      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <Button
          data-tip
          type="button"
          data-for="addDevices"
          isBackgroundColor={false}
          title="Add Devices"
          icon="mdi mdi-database-plus mr-2"
          onClick={(e) => {}}
          data-toggle="modal"
          data-target="#add_device"
          className="btn text-white btn-block btn-primary float-right"
        />
      </div>
    </div>
  );
};

TopInput.propTypes = {
  loading: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  allLocations: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired
};

export default TopInput;
